import { Link } from "react-router-dom"
import { FaWhatsapp, FaArrowRight } from "react-icons/fa"
import { motion } from "framer-motion"

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4 lg:px-8 py-16 lg:py-24">

        <div className="grid lg:grid-cols-2 gap-12 items-center">

          {/* Contenu */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
          >
            <span className="inline-block bg-gray-100 text-gray-700 text-sm font-medium px-4 py-2 rounded-full mb-6">
              Grossiste Textile & Mercerie
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-gray-900">
              Votre partenaire en
              <span className="block text-blue-600">
                fournitures textiles
              </span>
            </h1>

            <p className="mt-6 text-lg text-gray-600 leading-relaxed max-w-xl">
              Découvrez une large sélection de fermetures, fils,
              élastiques, tissus, velcro, boutons et accessoires
              destinés aux professionnels du textile et de la confection.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-8">

              <Link
                to="/produits"
                className="inline-flex items-center justify-center gap-2 bg-gray-900 hover:bg-black text-white px-6 py-4 rounded-xl font-semibold transition"
              >
                Voir les produits
                <FaArrowRight />
              </Link>

              <a
                href="https://wa.me/21628718432"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-4 rounded-xl font-semibold transition"
              >
                <FaWhatsapp />
                WhatsApp
              </a>

            </div>

            {/* Statistiques */}
            <div className="grid grid-cols-3 gap-6 mt-12">

              <div>
                <h3 className="text-2xl font-bold text-gray-900">
                  50+
                </h3>
                <p className="text-gray-600 text-sm">
                  Références
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900">
                  10+
                </h3>
                <p className="text-gray-600 text-sm">
                  Catégories
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900">
                  100%
                </h3>
                <p className="text-gray-600 text-sm">
                  Professionnel
                </p>
              </div>

            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
           <img
                src="/images/favicon.jpg"
                alt="Fournitures textiles professionnelles"
                className="w-full h-[400px] md:h-[550px] object-cover"
                loading="eager"
              />
              
            </div>

            
          {/*}  Carte flottante */}
            <div className="absolute bottom-6 left-6 bg-white rounded-2xl shadow-lg p-5">
              <p className="text-sm text-gray-500">
                Stock disponible
              </p>

              <h4 className="font-bold text-lg text-gray-900">
                Toute l'année
              </h4>
            </div>
            
          </motion.div>

        </div>

      </div>
    </section>
  )
}